import React, { useState } from 'react'
import { usePromise } from '../../utils/hooks/usePromise'
import { useGlobal } from 'reactn'
import { joinVisitationEventRaffle } from '../../services/main/joinVisitationEventRaffle'
import { unsubscribeFromRaffle } from '../../services/main/unsubscribeFromRaffle'
import { RaffleEmptyState } from './RaffleEmptyState'
import { RafflesList } from './RafflesList'
import { GetAvailableVisitationRaffles_listUserVisitEvents } from '../../services/types/getAvailableVisitationRaffles'
import { VisitEventStatusType } from '../../constants/types'

interface RaffleListProps {
  availableRaffles?: GetAvailableVisitationRaffles_listUserVisitEvents[]
}

export const Raffles: React.FC<RaffleListProps> = props => {
  const [availableRaffles] = useGlobal('availableVisitationEvents')
  const [shouldRefreshRaffles] = useGlobal('shouldRefreshRaffles')
  const [currentIdOfRaffleBeingUpdated, setCurrentIdOfRaffleBeingUpdated] = useState<string>('')

  const { request: joinRaffle, loading: isJoiningRaffle } = usePromise(joinVisitationEventRaffle)
  const { request: quitRaffle, loading: isQuittingRaffle } = usePromise(unsubscribeFromRaffle)

  const joinVisitationRaffle = (id: string) => {
    setCurrentIdOfRaffleBeingUpdated(id)
    joinRaffle(id)
  }

  const quitVisitationRaffle = (id: string) => {
    setCurrentIdOfRaffleBeingUpdated(id)
    quitRaffle(id)
  }

  const render = () => {
    const openedRaffles = availableRaffles
      ? availableRaffles.filter(item => item.visitEvent.eventStatus === VisitEventStatusType.open)
      : []
    if (!openedRaffles.length) {
      return <RaffleEmptyState />
    } else {
      return (
        <RafflesList
          joinRaffleCallback={joinVisitationRaffle}
          quitRaffleCallback={quitVisitationRaffle}
          isJoining={isJoiningRaffle}
          isQuitting={isQuittingRaffle}
          currentRaffleId={currentIdOfRaffleBeingUpdated}
        />
      )
    }
  }

  return <>{render()}</>
}
